module.exports = __webpack_public_path__ + "img/default2.f3cb9730.jpg";